module.exports = __webpack_public_path__ + "static/media/nimit_jain.06c5b364.jpg";